module.exports = __webpack_public_path__ + "img/invite-avatar@2x.be0a5936.png";